import type { Messages } from '../shape';

export const common = {
  cancel: 'Отмена',
  close: 'Закрыть',
  done: 'Готово',
  ok: 'ОК',
  save: 'Сохранить',
  saved: 'Сохранено',
  delete: 'Удалить',
  remove: 'Убрать',
  rename: 'Переименовать',
  open: 'Открыть',
  copy: 'Копировать',
  copied: 'Скопировано',
  retry: 'Повторить',
  back: 'Назад',
  loading: 'Загрузка…',
  justNow: 'только что',
  never: 'никогда',
  unknown: 'неизвестно',
} satisfies Messages['common'];
